import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface WrappedAccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  open?: boolean;
  disabled?: boolean;
  isWrapped?: boolean;
  onToggle?: () => void;
}

export default function WrappedAccordion({
  title,
  children,
  open = false,
  disabled = false,
  onToggle,
}: WrappedAccordionProps) {
  return (
    <Accordion
      disabled={disabled}
      value={open ? "open" : "closed"}
      type="single"
      collapsible
    >
      <AccordionItem
        className="bg-white-A700 p-6 rounded-lg shadow-sm no-underline border-none border-b-0"
        value="open"
      >
        <AccordionTrigger
          onClick={onToggle}
          className="p-0 no-underline border-none hover:no-underline"
        >
          {title}
        </AccordionTrigger>
        <AccordionContent className="p-0 border-none">
          {children}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}